// Connection Arcade - Spark prompts (v3)
// NOTE: Keep these intentional + playful. No humiliation, no coercion.

export const SPARK_CATEGORIES = {
  daily: {
    label: 'Daily Drop',
    blurb: 'Fresh, shareable, and made for today.',
  },
  signal: {
    label: 'Signal',
    blurb: 'Real questions. Low pressure. High clarity.',
  },
  spark: {
    label: 'Spark',
    blurb: 'Playful prompts that shift the energy.',
  },
  comedy: {
    label: 'Comedy',
    blurb: 'Honest humor. Self-aware flirting.',
  },
  expansive: {
    label: 'Constellation',
    blurb: 'Expansive love. Intentional connection.',
  },
};

// Each prompt: { id, type, text }
export const SPARK_PROMPTS = [
  // ─── SIGNAL (real + compatibility + values + repair) ───
  { id: 'sig_001', type: 'signal', text: 'What does "intentional dating" mean to you in one sentence?' },
  { id: 'sig_002', type: 'signal', text: 'What is one thing you are proud of about how you love?' },
  { id: 'sig_003', type: 'signal', text: 'What is your ideal pace for getting to know someone?' },
  { id: 'sig_004', type: 'signal', text: 'What is a boundary you are happy you learned to keep?' },
  { id: 'sig_005', type: 'signal', text: 'What is your love language in real life (not just the quiz answer)?' },
  { id: 'sig_006', type: 'signal', text: 'What is a small thing that instantly makes you feel cared for?' },
  { id: 'sig_007', type: 'signal', text: 'When conflict happens, what helps you feel safe enough to repair?' },
  { id: 'sig_008', type: 'signal', text: 'What is one value you will not compromise on in a relationship?' },
  { id: 'sig_009', type: 'signal', text: 'What helps you feel safe enough to be fully honest?' },
  { id: 'sig_010', type: 'signal', text: "What's a boundary you learned the hard way?" },
  { id: 'sig_011', type: 'signal', text: "What does 'being cared for' look like to you in real life?" },
  { id: 'sig_012', type: 'signal', text: "When you're stressed, what do you need from a partner?" },
  { id: 'sig_013', type: 'signal', text: "What's a green flag you wish people took seriously?" },
  { id: 'sig_014', type: 'signal', text: "What's your healthiest relationship habit?" },
  { id: 'sig_015', type: 'signal', text: 'How do you prefer to repair after an argument?' },
  { id: 'sig_016', type: 'signal', text: "What's something you're currently working on in yourself?" },
  { id: 'sig_017', type: 'signal', text: 'What makes you lose trust fast?' },
  { id: 'sig_018', type: 'signal', text: "What's a non-negotiable value for you?" },
  { id: 'sig_019', type: 'signal', text: "What's one thing you'll always make time for in a relationship?" },
  { id: 'sig_020', type: 'signal', text: 'What does consistency mean to you?' },
  { id: 'sig_021', type: 'signal', text: 'How do you like to receive affection (not just words)?' },
  { id: 'sig_022', type: 'signal', text: "What's a small everyday thing that makes you feel loved?" },
  { id: 'sig_023', type: 'signal', text: "What's something you need patience with?" },
  { id: 'sig_024', type: 'signal', text: "What's a relationship lesson you'd keep forever?" },
  { id: 'sig_025', type: 'signal', text: 'When you feel misunderstood, what helps most?' },
  { id: 'sig_026', type: 'signal', text: 'How do you handle jealousy when it shows up?' },
  { id: 'sig_027', type: 'signal', text: "What's your 'I'm overwhelmed' tell?" },
  { id: 'sig_028', type: 'signal', text: 'What does loyalty mean to you (in one sentence)?' },
  { id: 'sig_029', type: 'signal', text: "What's something you won't compromise on in commitment?" },
  { id: 'sig_030', type: 'signal', text: 'What do you want more of in your life this year?' },
  { id: 'sig_031', type: 'signal', text: "What's your definition of emotional maturity?" },
  { id: 'sig_032', type: 'signal', text: "What's one thing you need to feel respected?" },
  { id: 'sig_033', type: 'signal', text: "What's a simple way someone can support you on a hard day?" },

  // ─── SPARK (playful + viral + imaginative) ───
  { id: 'spk_001', type: 'spark', text: 'Describe your vibe today in 3 words.' },
  { id: 'spk_002', type: 'spark', text: 'Pick a theme song for your mood right now (artist + song title).' },
  { id: 'spk_003', type: 'spark', text: 'If your love style was a movie genre, what would it be?' },
  { id: 'spk_004', type: 'spark', text: 'Send a compliment you would give someone you are genuinely curious about.' },
  { id: 'spk_005', type: 'spark', text: 'What is a tiny date idea that would make you smile (under $10)?' },
  { id: 'spk_006', type: 'spark', text: 'Give a 1-line trailer voice pitch for dating you.' },
  { id: 'spk_007', type: 'spark', text: 'What is your signature move for making someone feel welcome?' },
  { id: 'spk_008', type: 'spark', text: 'If we time-traveled to your perfect Saturday, what are we doing?' },
  { id: 'spk_009', type: 'spark', text: "What's your most underrated date idea under $20?" },
  { id: 'spk_010', type: 'spark', text: 'You get one superpower for dating. What is it?' },
  { id: 'spk_011', type: 'spark', text: "We're stuck in an elevator for 10 minutes. What do you say first?" },
  { id: 'spk_012', type: 'spark', text: "What's your 'red flag'... that's actually just a quirk?" },
  { id: 'spk_013', type: 'spark', text: "What's the most charming thing someone could do on a first date?" },
  { id: 'spk_014', type: 'spark', text: "What's a tiny romantic gesture that hits way too hard?" },
  { id: 'spk_015', type: 'spark', text: 'If our first date had a movie title, what would it be?' },
  { id: 'spk_016', type: 'spark', text: "What's your 'I'm flirting' giveaway?" },
  { id: 'spk_017', type: 'spark', text: "You can plan a 2-hour micro-date anywhere. Where are we going?" },
  { id: 'spk_018', type: 'spark', text: "If we were a duo on a road trip, who's DJ and who's navigator?" },
  { id: 'spk_019', type: 'spark', text: "What's the funniest compliment you've ever received?" },
  { id: 'spk_020', type: 'spark', text: "What's a smell that instantly makes you feel cozy?" },
  { id: 'spk_021', type: 'spark', text: "What's a fictional couple you'd beat in a relationship competition?" },
  { id: 'spk_022', type: 'spark', text: "If we had a secret handshake, what's one move in it?" },
  { id: 'spk_023', type: 'spark', text: "What's your 'I like you' test (be honest)?" },
  { id: 'spk_024', type: 'spark', text: "What's a harmless thing that gives you butterflies?" },
  { id: 'spk_025', type: 'spark', text: "What's your favorite kind of playful teasing?" },
  { id: 'spk_026', type: 'spark', text: 'We can teleport for dinner. Where are we eating?' },
  { id: 'spk_027', type: 'spark', text: "What's a random skill you have that sounds fake?" },
  { id: 'spk_028', type: 'spark', text: "What's the best 'lazy date' idea that still feels romantic?" },
  { id: 'spk_029', type: 'spark', text: 'If we swapped phones for 60 seconds, what would you hide first?' },
  { id: 'spk_030', type: 'spark', text: 'What would your friends say is your best dating quality?' },
  { id: 'spk_031', type: 'spark', text: "What's a first-date question that always reveals a lot?" },
  { id: 'spk_032', type: 'spark', text: 'If our vibe had a color, what color is it?' },

  // ─── COMEDY (honest humor + self-aware flirting) ───
  { id: 'com_001', type: 'comedy', text: "What's your most dramatic 'I'm fine' moment?" },
  { id: 'com_002', type: 'comedy', text: "What's your harmless delusion in relationships?" },
  { id: 'com_003', type: 'comedy', text: "What's a petty hill you will absolutely die on?" },
  { id: 'com_004', type: 'comedy', text: "What's your 'I caught feelings' warning sign?" },
  { id: 'com_005', type: 'comedy', text: "What's something your friends roast you for?" },
  { id: 'com_006', type: 'comedy', text: "What's your most unserious relationship fear?" },
  { id: 'com_007', type: 'comedy', text: "What's your toxic trait... but make it adorable?" },
  { id: 'com_008', type: 'comedy', text: "What's the funniest compliment you've believed?" },
  { id: 'com_009', type: 'comedy', text: "What's a red flag you once misread as charisma?" },
  { id: 'com_010', type: 'comedy', text: "What's your 'I'm jealous but pretending I'm not' behavior?" },
  { id: 'com_011', type: 'comedy', text: "What's a tiny inconvenience that ruins your whole mood?" },
  { id: 'com_012', type: 'comedy', text: "What's your most overthought dating scenario?" },
  { id: 'com_013', type: 'comedy', text: "What's your 'I'm trying to act cool' move?" },
  { id: 'com_014', type: 'comedy', text: "What's something you romanticize way too hard?" },
  { id: 'com_015', type: 'comedy', text: "What's your 'soft launch' personality trait?" },
  { id: 'com_016', type: 'comedy', text: "What's the most unserious argument topic you've had?" },
  { id: 'com_017', type: 'comedy', text: "What's your 'I need attention but won't say it' move?" },
  { id: 'com_018', type: 'comedy', text: "What's your weirdest comfort habit?" },
  { id: 'com_019', type: 'comedy', text: "What's a harmless thing that gives you butterflies?" },
  { id: 'com_020', type: 'comedy', text: "What's your most chaotic green flag?" },
  { id: 'com_021', type: 'comedy', text: "What's your favorite playful form of teasing?" },
  { id: 'com_022', type: 'comedy', text: "What's something you pretend to hate but secretly love?" },
  { id: 'com_023', type: 'comedy', text: "What's your 'main character' moment this year?" },
  { id: 'com_024', type: 'comedy', text: "What's your most relatable relationship flaw?" },
  { id: 'com_025', type: 'comedy', text: "What's your 'I'm emotionally available (probably)' sign?" },

  // ─── CONSTELLATION (expansive love + intentional connection) ───
  { id: 'exp_001', type: 'expansive', text: 'What does ethical non-monogamy mean to you?' },
  { id: 'exp_002', type: 'expansive', text: 'How do you personally define jealousy?' },
  { id: 'exp_003', type: 'expansive', text: 'What helps you feel secure when attention is shared?' },
  { id: 'exp_004', type: 'expansive', text: 'Do you lean toward structure or flexibility in relationships?' },
  { id: 'exp_005', type: 'expansive', text: 'What makes you feel prioritized without exclusivity?' },
  { id: 'exp_006', type: 'expansive', text: "What's a boundary you'd clearly need respected?" },
  { id: 'exp_007', type: 'expansive', text: 'How do you manage time intentionally in relationships?' },
  { id: 'exp_008', type: 'expansive', text: 'What does loyalty look like outside exclusivity?' },
  { id: 'exp_009', type: 'expansive', text: 'How do you handle emotional overwhelm?' },
  { id: 'exp_010', type: 'expansive', text: "What's something people misunderstand about open dynamics?" },
  { id: 'exp_011', type: 'expansive', text: 'How do you prefer difficult conversations to be handled?' },
  { id: 'exp_012', type: 'expansive', text: 'What kind of transparency feels healthy to you?' },
  { id: 'exp_013', type: 'expansive', text: 'How do you protect emotional safety for everyone involved?' },
  { id: 'exp_014', type: 'expansive', text: "What's your biggest communication strength?" },
  { id: 'exp_015', type: 'expansive', text: 'Do you prefer hierarchy, equal footing, or fluid roles?' },
  { id: 'exp_016', type: 'expansive', text: 'What role does independence play in love for you?' },
  { id: 'exp_017', type: 'expansive', text: 'How do you celebrate multiple connections without comparison?' },
  { id: 'exp_018', type: 'expansive', text: "What's your biggest growth edge in relationships?" },
  { id: 'exp_019', type: 'expansive', text: 'How do you reset after feeling insecure?' },
  { id: 'exp_020', type: 'expansive', text: 'What does fairness mean to you in shared dynamics?' },
  { id: 'exp_021', type: 'expansive', text: 'How do you handle imbalance in attention?' },
  { id: 'exp_022', type: 'expansive', text: 'What kind of reassurance feels grounding?' },
  { id: 'exp_023', type: 'expansive', text: 'What dynamic would you never want to repeat?' },
  { id: 'exp_024', type: 'expansive', text: 'What is your honest curiosity about expansive love?' },
  { id: 'exp_025', type: 'expansive', text: 'How do you define commitment in an open structure?' },

  // ─── DAILY DROP (super shareable, shows first) ───
  { id: 'day_001', type: 'daily', text: 'Tell me your love language, but make it funny.' },
  { id: 'day_002', type: 'daily', text: "What's your biggest 'green flag' flex?" },
  { id: 'day_003', type: 'daily', text: 'Describe your vibe today in 3 words.' },
  { id: 'day_004', type: 'daily', text: "What's a date idea that would instantly win you over?" },
  { id: 'day_005', type: 'daily', text: "What's a tiny thing that makes you feel chosen?" },
  { id: 'day_006', type: 'daily', text: "What's your most attractive habit?" },
];

// Get today's Daily Drop (stable per calendar day, rotates daily)
export function getDailyDrop() {
  const dailies = SPARK_PROMPTS.filter((p) => p.type === 'daily');
  if (!dailies.length) return null;
  const today = new Date();
  const dayIndex = (today.getFullYear() * 366 + today.getMonth() * 31 + today.getDate()) % dailies.length;
  return dailies[dayIndex];
}

export function getRandomSparkPrompt(type = 'any') {
  const pool =
    type === 'any'
      ? SPARK_PROMPTS
      : SPARK_PROMPTS.filter((p) => p.type === type);

  if (!pool.length) return null;
  const idx = Math.floor(Math.random() * pool.length);
  return pool[idx];
}
